module.exports = window['adobe_dc_sdk']['dc-spectrum-v3-core'];